const ROVING_TAB_KEYS = ["ArrowRight", "ArrowLeft", "Home", "End"];

export const getNextRovingIndex = (key, currentIndex, itemCount) => {
  if (currentIndex < 0 || itemCount <= 0 || !ROVING_TAB_KEYS.includes(key)) {
    return currentIndex;
  }

  if (key === "ArrowRight") {
    return (currentIndex + 1) % itemCount;
  }

  if (key === "ArrowLeft") {
    return (currentIndex - 1 + itemCount) % itemCount;
  }

  if (key === "Home") {
    return 0;
  }

  return itemCount - 1;
};

export const handleRovingTabKeyDown = ({
  event,
  items,
  currentItem,
  onChange,
  getElementId,
}) => {
  if (!ROVING_TAB_KEYS.includes(event.key)) {
    return false;
  }

  const currentIndex = items.indexOf(currentItem);
  if (currentIndex < 0 || items.length === 0) {
    return false;
  }

  const nextIndex = getNextRovingIndex(event.key, currentIndex, items.length);
  event.preventDefault();
  const nextItem = items[nextIndex];
  onChange(nextItem, nextIndex);

  if (getElementId) {
    setTimeout(() => {
      document.getElementById(getElementId(nextItem, nextIndex))?.focus();
    }, 0);
  }

  return true;
};
